import type React from "react";
import { useMemo } from "react";
import { TopPageWidgetsRow } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTopWidgetSingleContainer";
import {
    SearchOverviewTableCompareWrapper,
    SearchOverviewOrganicVSPaidCompareWrapper,
    BrandedNonBrandedCompareWrapper,
} from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTableCompareWrapper";
import type { ISearchOverviewTopWidgetContainer } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";

export const SearchOverviewTopWidgetCompareContainer: React.FunctionComponent<ISearchOverviewTopWidgetContainer> = (
    props,
) => {
    const { subtitleFilters, apiParams, isTotal } = props;
    const { webSource, country, key, isWindow, isWWW, to, from } = apiParams;

    const apiParamsObj = useMemo(() => {
        return {
            country,
            from,
            to,
            includeSubDomains: !isWWW,
            isWindow,
            keys: key,
            timeGranularity: "Monthly",
            webSource,
        };
    }, [country, from, to, isWWW, isWindow, key, webSource]);
    return (
        <TopPageWidgetsRow>
            <SearchOverviewTableCompareWrapper
                subtitleFilters={subtitleFilters}
                apiParams={apiParams}
                apiParamsObj={apiParamsObj}
            />
            <SearchOverviewOrganicVSPaidCompareWrapper
                subtitleFilters={subtitleFilters}
                apiParams={apiParams}
                apiParamsObj={apiParamsObj}
            />
            <BrandedNonBrandedCompareWrapper
                subtitleFilters={subtitleFilters}
                apiParams={apiParams}
                apiParamsObj={apiParamsObj}
            />
        </TopPageWidgetsRow>
    );
};
